<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<div class="alert alert-warning" role="alert">
	Долгий период времени был потерян код(не отделом статистики), который логировал заход на страницу тарифов. Была попытка восстановить эту информацию из логов NGINX, но восстановить нужную информацию получилось только частично. Из-за отсутствия информации за большой период времени, на графике виден большой всплеск у столбца со значением 0. В марте мы вернули потерянный код по логированию   заходов на страницу тарифов и, если выставить фильтр по дате создания сайта за март этого года, то всплеск у значения 0 пропадает. Этот всплеск не падает до нуля, т. к. есть сайты, которые имеют статус платных, но не имеют первичного ручного платежа, например, uber сайты.
</div>


<div class="row">
	<div class="col-md-12">
		<chart [data]="chartData.data" [options]="chartData.options" [sextant]="'chart'" [url]="filter.currentUrl"></chart>
	</div>
</div>
